module.exports = __webpack_public_path__ + "img/avatar.802f160a.jpg";